export default {
  label: {
    original: 'Original: ',
    originalNotFound: 'Not found',
    reloadButtonText: 'Reload',
    errorMessage: 'Error loading data',
  },
};
